module.exports = __webpack_public_path__ + "img/giftcard_failed.b68efcba.svg";